<div class="snackbar-container">
  <div class="snackbar-content">
    <span class="message" matSnackBarLabel>
      {{ message }}
    </span>
    
    <span class="action-wrapper" *ngIf="actionType !== 'login'">
      <div class="dismiss-button" (click)="snackBarRef.dismissWithAction()">
        <span class="fa-solid fa-x"></span>
      </div>
    </span>
    
    <span class="action-wrapper" *ngIf="actionType === 'login'">
      <div class="login-button" (click)="snackBarRef.dismissWithAction()">
        Log In
      </div>
    </span>
  </div>
</div>